/**
 * Created by jonas on 2020-10-01.
 */


import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {APIEventSystem} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {LonerSymbolStates, SimpleReelModelState} from "../../core/reel/ReelInterfaces";
import {gsap} from "gsap";
import {LonerMainReelView} from "../view/mainReels/LonerMainReelView";
import {Loner} from "../Loner";
import {SymbolUtils} from "../utils/SymbolUtils";
import {LonerSymbol} from "./symbols/main/LonerSymbol";

export interface SimpleReelModelEventData {
    reel:number;
    state:SimpleReelModelState;
}

export interface SimpleReelPaddingData {
    visualPaddingBefore:number;
    paddingBefore:number;
    visibleSymbols:number;
    paddingAfter:number;
    visualPaddingAfter:number;
}

export class LonerReelModel {
    private readonly _reelId:number;
    private readonly _reelView:LonerMainReelView;
    private _state:SimpleReelModelState = SimpleReelModelState.IDLE;

    /**
     * Triggers on: ReelStateChange and each ReelModelState
     */
    public readonly events:APIEventSystem | undefined;

    constructor(id:number, triggerEvents:boolean = true) {
        this._reelId = id;
        this._reelView = new LonerMainReelView(id, (state:SimpleReelModelState) => this.setState(state));
        if(triggerEvents) {
            this.events = SlotGame.apiPlugin.eventSystemFactory.create();
            this.events.on("ReelStateChange", (data:SimpleReelModelEventData) => this.onReelStateChange(data));
        }
    }

    public start():gsap.core.Timeline {
        return this._reelView.start();
    }

    public fakeStart():void {
        return this._reelView.doFakeSpine();
    }

    public getReadyToStop():void {
        this.reelView.stop();
    }

    public doStop(reelData:string[]):void {
        this._reelView.doStop(reelData);
    }

    private onReelStateChange(data:SimpleReelModelEventData):void {
        this.events?.trigger(data.state.toString(), data);
    }

    private setState(state:SimpleReelModelState) {
        this._state = state;
        if(this.events) {
            this.events.trigger("ReelStateChange", <SimpleReelModelEventData>{
                reel : this._reelId,
                state : this._state
            });
        }
    }

    //Use this to switch between different types of symbols
    public switchSymbol(newSymbolName:string, symbolPosition:number):LonerSymbol {
        const newSymbol:LonerSymbol = SymbolUtils.getSymbol(true, newSymbolName, LonerSymbolStates.NORMAL, {
            reelID : this._reelId,
            position : symbolPosition,
            targetPosition: 0
        });
        this.reelView.switchSymbol(newSymbol, symbolPosition);

        return newSymbol;
    }

    get state():SimpleReelModelState {
        return this._state;
    }

    get reelView():LonerMainReelView {
        return this._reelView;
    }
}